import React, { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { t } from 'i18next';
import Select from 'react-select';
import { fxSelectStyles } from './AddExpenses';

interface Props {
  access: any;
  value: number | null;              // выбранный сотрудник (от кого)
  onChange: (id: number | null) => void;
}

const labelSm =
  'text-[10px] font-semibold uppercase tracking-[.04em] text-[var(--text-color-calendar-week)] mb-[4px] block';

// «От кого» (сотрудник-заявитель) + «Супервайзер» (авто, только показ).
const ClaimantFields: React.FC<Props> = ({ access, value, onChange }) => {
  const [users, setUsers] = useState<any[]>([]);

  const canForOthers =
    access?.finance_create_for_others === true ||
    access?.finance_create_for_others === 1;

  useEffect(() => {
    (async () => {
      try {
        const [{ data: us }, { data: me }] = await Promise.all([
          axios.get('users'),
          axios.get('user'),
        ]);
        setUsers(Array.isArray(us) ? us : []);
        if (value == null && me?.id != null) onChange(me.id);
      } catch {
        /* interceptor */
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const options = useMemo(
    () => users.map((u) => ({ value: u.id, label: `${u.first_name} ${u.last_name}` })),
    [users],
  );
  const usersById = useMemo(() => new Map(users.map((u) => [u.id, u])), [users]);

  const selected = options.find((o) => o.value === value) || null;
  const employee = value != null ? usersById.get(value) : null;
  const supervisor =
    employee?.supervisorId != null ? usersById.get(employee.supervisorId) : null;
  const supervisorName = supervisor
    ? `${supervisor.first_name} ${supervisor.last_name}`
    : '—';

  return (
    <div className="fx-row2">
      <div className="fx-field">
        <span className={labelSm}>{t('FromWhom') || 'From'}</span>
        {canForOthers ? (
          <Select
            classNamePrefix="app-rs"
            options={options}
            value={selected}
            onChange={(v: any) => onChange(v ? v.value : null)}
            placeholder={t('FromWhom') || 'From'}
            styles={fxSelectStyles}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
          />
        ) : (
          <div
            className="fx-input"
            style={{ display: 'flex', alignItems: 'center', gap: 6, opacity: 0.75, cursor: 'not-allowed' }}
          >
            🔒 {selected?.label ?? '—'}
          </div>
        )}
      </div>
      <div className="fx-field">
        <span className={labelSm}>{t('Supervisor') || 'Supervisor'}</span>
        <div
          className="fx-input"
          style={{ display: 'flex', alignItems: 'center', gap: 6, opacity: 0.75 }}
        >
          👤 {supervisorName}
        </div>
      </div>
    </div>
  );
};

export default ClaimantFields;
